<template>
  <div></div>
</template>
<script>
import moment from "moment";

export default {
  name: "profile",
  props: {
    guide: {
      type: Object,
      required: true
    },
    userProfile: {
      type: Object,
      required: true
    },
    plan: {
      type: Object,
      required: true
    }
  },
  created() {},
  computed: {
    getDate() {
      return moment(this.successBook.date).format("dddd, MMMM DD");
    },
    getTime() {
      return moment(`${this.successBook.date} ${this.successBook.time}`).format(
        "hh:mm A"
      );
    }
  },
  methods: {
    handleBookClick() {
      this.showBookingModal = true;
    },
    handleSetDay(input) {
      this.bookingDay = input;
      this.tabActiveKey = "settime";
    },
    handleSetTime(input) {
      this.bookingTime = input;
      //Go to Next View
      this.tabActiveKey = "bookcomplete";
    },
    handleBookSessionClick() {
      let dayTime = `${this.bookingDay} ${this.bookingTime.value}`;
      let fullTime = moment(dayTime, "YYYY-MM-DD hh:mm:ss");

      this.$store
        .dispatch("session/createSession", {
          _booked_at: fullTime.toDate(),
          room_id: `${this.guide.userId}_${
            this.$store.getters["user/user"].uid
          }_${moment().unix()}`,
          guide: {
            user_id: this.guide.userId,
            firstname: this.guide.user.firstname,
            lastname: this.guide.user.lastname,
            imgURL: this.guide.user.imgURL
          },
          user: {
            user_id: this.$store.getters["user/user"].uid,
            firstname: this.userProfile.firstname,
            lastname: this.userProfile.lastname,
            imgURL: this.userProfile.imgURL ? this.userProfile.imgURL : null
          },
          plan: {
            id: 1,
            price: this.plan.price,
            title: this.plan.title,
            summary: this.plan.summary
          }
        })
        .then(() => {
          this.$store.dispatch("user/showNotification", {
            title: `'${this.plan.title}' Session Booked`,
            description: "Awesome. You will receive an email",
            variant: "success"
          });
          this.successBook = { date: this.date, time: this.time, type: "all" };
          this.date = "";
          this.time = "";
          setTimeout(() => {
            this.successBook = null;
          }, 15000);
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
      this.showBookingModal = false;
    },
    handleTabBack() {
      switch (this.tabActiveKey) {
        case "settime":
          this.tabActiveKey = "setday";
          break;
        case "bookcomplete":
          this.tabActiveKey = "settime";
          break;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 || day === 13;
    }
  },
  data() {
    return {
      bookingDay: null,
      bookingTime: null,
      showBookingModal: false,
      value: "",
      tabActiveKey: "setday",
      availTimes: [
        {
          text: "9:30AM",
          value: "09:15:00"
        },
        {
          text: "10:30AM",
          value: "10:30:00"
        }
      ]
    };
  }
};
</script>
